import React, { SVGProps, useId } from "react";

export const HappyIcon = (props: SVGProps<SVGSVGElement>) => {
  const a = useId();
  const b = useId();
  const d = useId();
  const f = useId();
  const g = useId();
  const i = useId();
  const k = useId();
  const c = useId();
  const e = useId();
  const h = useId();
  const j = useId();
  const l = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 80 80"
      {...props}
    >
      <path
        fill={`url(#${a})`}
        d="M40.475 70.95c16.83 0 30.475-13.644 30.475-30.475C70.95 23.645 57.306 10 40.475 10 23.645 10 10 23.644 10 40.475c0 16.83 13.644 30.475 30.475 30.475Z"
      />
      <path
        fill={`url(#${b})`}
        d="M40.475 70.95c16.83 0 30.475-13.644 30.475-30.475C70.95 23.645 57.306 10 40.475 10 23.645 10 10 23.644 10 40.475c0 16.83 13.644 30.475 30.475 30.475Z"
        opacity={0.5}
      />
      <path
        fill={`url(#${c})`}
        d="M33.402 20.56c-.284-1.19-1.744-1.63-3.955-1.106-1.885.454-5.755 2.467-7.725 6.79-.368.794.525.978.936.41 1.389-1.898 5.613-4.918 9.369-5.385 1.517-.185 1.375-.71 1.375-.71Z"
      />
      <path
        fill={`url(#${d})`}
        d="M30.525 40.362c1.824 0 3.302-2.964 3.302-6.62s-1.478-6.62-3.302-6.62-3.303 2.964-3.303 6.62 1.479 6.62 3.303 6.62Z"
      />
      <path
        fill={`url(#${e})`}
        d="M30.525 29.362c1.417 0 2.65 1.645 3.288 4.054-.043-3.586-1.503-6.463-3.288-6.463-1.8 0-3.246 2.877-3.289 6.463.638-2.41 1.871-4.054 3.289-4.054Z"
      />
      <path
        fill={`url(#${f})`}
        d="M61.056 45.635a1.106 1.106 0 0 0-.709-.029A72.083 72.083 0 0 1 40.49 48.37a72.546 72.546 0 0 1-19.858-2.764 1.102 1.102 0 0 0-.709.029c-.694.283-1.8 1.332-.34 5.343v.014c2.154 5.132 7.867 14.146 20.893 14.146 12.998 0 18.71-9.029 20.922-14.146 1.445-4.025.354-5.074-.34-5.357Z"
      />
      <path
        fill={`url(#${g})`}
        d="M40.475 63.707c5.4 0 9.454-1.659 12.488-3.926-3.331-1.503-7.442-2.481-12.488-2.481-5.046 0-9.157.992-12.488 2.509 3.034 2.24 7.088 3.898 12.488 3.898Z"
      />
      <path
        fill={`url(#${h})`}
        d="M60.645 45.55c-.043 0-.085 0-.142.014a72.295 72.295 0 0 1-20.042 2.82c-6.818 0-13.551-.95-20.043-2.82-.043-.015-.085-.015-.142-.015-.44.043-2.537.482-.737 5.443v.015c.88 2.07 2.339 4.776 4.621 7.257-2.14-2.537.496-3.94 5.188-3.374 4.692.567 11.113.581 11.113.581s6.407-.014 11.112-.58c4.692-.568 7.329.836 5.188 3.373 2.282-2.48 3.742-5.188 4.621-7.257v-.015c1.8-4.975-.297-5.414-.737-5.443Z"
      />
      <path
        fill={`url(#${i})`}
        d="M57.03 52.523a4.187 4.187 0 0 0 3.303-3.7l.17-1.785a73.843 73.843 0 0 1-20.028 2.764 73.844 73.844 0 0 1-20.029-2.764l.17 1.786c.17 1.814 1.517 3.302 3.303 3.7a78.009 78.009 0 0 0 16.556 1.757c5.585 0 11.141-.595 16.556-1.758Z"
      />
      <path
        fill={`url(#${j})`}
        d="M47.548 20.56c.283-1.19 1.743-1.63 3.955-1.106 1.885.454 5.754 2.467 7.725 6.79.368.794-.525.978-.936.41-1.389-1.898-5.613-4.918-9.37-5.385-1.516-.185-1.374-.71-1.374-.71Z"
      />
      <path
        fill={`url(#${k})`}
        d="M50.425 40.362c1.824 0 3.303-2.964 3.303-6.62s-1.479-6.62-3.303-6.62c-1.824 0-3.302 2.964-3.302 6.62s1.478 6.62 3.302 6.62Z"
      />
      <path
        fill={`url(#${l})`}
        d="M50.425 29.362c-1.417 0-2.65 1.645-3.288 4.054.042-3.586 1.502-6.463 3.288-6.463 1.8 0 3.246 2.877 3.289 6.463-.638-2.41-1.871-4.054-3.289-4.054Z"
      />
      <defs>
        <radialGradient
          id={a}
          cx={0}
          cy={0}
          r={1}
          gradientTransform="translate(34.479 28.125) scale(36.7641)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDF30" />
          <stop offset={1} stopColor="#FFB82E" />
        </radialGradient>
        <radialGradient
          id={b}
          cx={0}
          cy={0}
          r={1}
          gradientTransform="translate(34.479 28.125) scale(28.924)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE95F" />
          <stop offset={1} stopColor="#FFBB47" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id={d}
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(77.72 -6.28 35.278) scale(6.31807 3.18039)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.001} stopColor="#7A4400" />
          <stop offset={1} stopColor="#643800" />
        </radialGradient>
        <radialGradient
          id={f}
          cx={0}
          cy={0}
          r={1}
          gradientTransform="translate(40.475 55.35) scale(16.7881)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.001} stopColor="#7A4400" />
          <stop offset={1} stopColor="#643800" />
        </radialGradient>
        <radialGradient
          id={g}
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(13.9137 0 0 4.2061 40.727 61.255)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.248} stopColor="red" />
          <stop offset={1} stopColor="#C10000" />
        </radialGradient>
        <radialGradient
          id={i}
          cx={0}
          cy={0}
          r={1}
          gradientTransform="translate(40.475 50.666) scale(36.8167)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.001} stopColor="#fff" />
          <stop offset={1} stopColor="#A8BBBD" />
        </radialGradient>
        <radialGradient
          id={k}
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(102.28 12.052 37.672) scale(6.31807 3.18039)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.001} stopColor="#7A4400" />
          <stop offset={1} stopColor="#643800" />
        </radialGradient>
        <linearGradient
          id={c}
          x1={27.625}
          x2={26.882}
          y1={24.029}
          y2={20.905}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.001} stopColor="#3C2200" />
          <stop offset={1} stopColor="#7A4400" />
        </linearGradient>
        <linearGradient
          id={e}
          x1={30.525}
          x2={30.525}
          y1={27.087}
          y2={33.26}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.001} stopColor="#3C2200" />
          <stop offset={1} stopColor="#512D00" />
        </linearGradient>
        <linearGradient
          id={h}
          x1={61.866}
          x2={19.344}
          y1={51.898}
          y2={51.898}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.001} stopColor="#3C2200" />
          <stop offset={0.5} stopColor="#512D00" />
          <stop offset={1} stopColor="#3C2200" />
        </linearGradient>
        <linearGradient
          id={j}
          x1={53.319}
          x2={54.063}
          y1={24.02}
          y2={20.896}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.001} stopColor="#3C2200" />
          <stop offset={1} stopColor="#7A4400" />
        </linearGradient>
        <linearGradient
          id={l}
          x1={50.425}
          x2={50.425}
          y1={27.087}
          y2={33.26}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.001} stopColor="#3C2200" />
          <stop offset={1} stopColor="#512D00" />
        </linearGradient>
      </defs>
    </svg>
  );
};
